<!-- Jobs and tasks list -->
<div class="ch-panel">
  <div class="ch-panel-title">
    Jobs Templates

    <div
      tooltip="Magic Template"
      class="view-type d-flex"
      (click)="newJobMagicTemplate(createAIJobModal)"
      style="right: 50px"
    >
      <i class="tio-magic_wand"></i>
    </div>
    <div
      class="view-type d-flex"
      (click)="newJobTemplate()"
      tooltip="New Job Template"
    >
      <i class="primary feather plus"></i>
    </div>
  </div>

  <div class="search-container" style="width: 340px">
    <div class="flex-grow-1">
      <label for="search-clients" class="search-label">
        <i class="feather search"></i>
        <input
          id="search-clients"
          name="search-clients"
          type="text"
          placeholder="Search"
          [(ngModel)]="searchTemplateInput"
          (ngModelChange)="applyFilter()"
        />
      </label>
    </div>
    <ch-tag-add
      style="cursor: pointer; position: relative; margin-left: -24px"
      class="sidebar-tag-add"
      #tagList
      [removeTagOnClick]="false"
      [extension]="extension"
      (tagClick)="addTagToFilter($event)"
      (andOrFilterChanged)="changeAndOrFilter($event)"
      [icon]="icon"
      [autoClose]="true"
    ></ch-tag-add>
    <ng-template #icon>
      <div class="tag-add" tooltip="Filter by tags">
        @if (selectedFilterTags.length == 0) {
          <i class="tio-filter_outlined" style="opacity: 0.6"></i>
        }
        @if (selectedFilterTags.length > 0) {
          <i class="tio-filter"></i>
        }
      </div>
    </ng-template>

    <ng-template #extension>
      @if (selectedFilterTags.length > 0) {
        <h4 style="font-size: 20px">Selected tags:</h4>
      }
      @if (selectedFilterTags.length > 0) {
        <p style="font-size: 14px">
          Show items with
          <b>{{
            andOrFilter == "and" ? "all" : andOrFilter == "or" ? "any" : "none"
          }}</b>
          of these tags:
        </p>
      }
      @for (tag of selectedFilterTags; track tag) {
        <ch-tag
          [name]="tag.name"
          [color]="tag.color"
          (click)="removeTagFromFilter(tag)"
        ></ch-tag>
      }
      @if (selectedFilterTags.length > 0) {
        <div>
          <hr />
          <button class="btn btn-default" (click)="clearFilter()">Clear</button>
        </div>
      }
    </ng-template>
  </div>

  <!-- List of jobs -->
  <div class="ch-panel-content jobs-template-list">
    <div class="ch-tabs" style="margin: 0 15px">
      <div
        [ngClass]="{ active: activeTab == 'templates' }"
        (click)="switchJobsTabs('templates')"
      >
        Firm Templates
      </div>
      <div
        [ngClass]="{ active: activeTab == 'global' }"
        (click)="switchJobsTabs('global')"
      >
        Client Hub Templates
      </div>
    </div>
    <div
      id="jobs-tab"
      class="ch-tabs-content-wrapper"
      [ngClass]="{ 'component-loading': loading }"
    >
      <app-jobs-and-tasks-card
        [job]="j"
        *ngFor="let j of filteredTemplates"
        [templateManager]="true"
        (click)="selectJob(j)"
      >
      </app-jobs-and-tasks-card>
    </div>
  </div>
</div>

<div class="ch-panel-content" *ngIf="selectedJob != null">
  <div id="jobs-tab" class="ch-tabs-content-wrapper">
    <app-job-content
      [job]="selectedJob"
      [templateManager]="true"
      class="is-template"
      [ngClass]="{ 'prevent-click': selectedJob.is_master_template }"
    ></app-job-content>
  </div>
</div>

<ng-template #createAIJobModal id="createAIJobModal">
  <div class="modal-header">
    <button
      type="button"
      class="btn-close"
      (click)="modalRef.hide()"
      aria-label="Close"
      [disabled]="loading"
    >
      <i class="feather x"></i>
    </button>
    <h4 class="modal-title">Magic Workflow</h4>
  </div>
  <div
    class="modal-body white text-center create-job-modal"
    [ngClass]="{ 'is-loading': loading }"
  >
    <div class="ai-bot-wrapper">
      <div class="ai-bot-face ai-bot-loading-wrapper">
        <img
          class="ai-bot-face ai-bot-loading"
          src="/assets/img/ai-bot-loading.svg"
        />
        <img
          class="ai-bot-face ai-bot-sparkles"
          src="/assets/img/ai-bot-sparkles.svg"
        />
      </div>
      <img class="ai-bot-face ai-bot-eyes" src="/assets/img/ai-bot-eyes.svg" />
      <img
        class="ai-bot animated"
        src="/assets/img/ai-bot.svg"
        alt="AI Bot avatar"
      />
      <svg
        class="ai-bot-shadow"
        width="134"
        height="28"
        viewBox="0 0 134 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <ellipse cx="67" cy="14" rx="67" ry="14" fill="#E6E9ED" />
      </svg>
    </div>
    <div class="default-content">
      <h3 class="mt-0 mb-2">Briefly describe the job that you need to do</h3>
      <p>We will auto-generate tasks and task details for it using AI.</p>
      <div class="row">
        <div class="col-sm-1"></div>
        <div class="col-sm-10">
          <textarea
            class="form-control chat-input my-4"
            autosize
            [(ngModel)]="aiJobDescription"
            placeholder="e.g. 1099 tax form"
          ></textarea>
        </div>
      </div>
    </div>
    <div class="loading-content">
      <h3 class="mt-0 mb-2">Generating Job using AI</h3>
      <p>Please wait, it may take up to 30 seconds.</p>
    </div>
  </div>
  <div class="modal-footer">
    <div
      class="btn btn-default pull-left"
      aria-label="Cancel"
      (click)="modalRef.hide()"
    >
      Cancel
    </div>
    <button
      class="btn btn-primary pull-right"
      (click)="createAIJob()"
      [disabled]="loading"
    >
      Generate Job
    </button>
  </div>
</ng-template>
